/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.17",
    versionName: "0.2.0-nightly.2026.2.17",
    versionChannel: "nightly",
    buildDate: "2026-02-17T00:12:49.762Z",
    commitHash: "616732b7fd7dc25a2297d156dd3b3fc8838f9522",
};
